module.exports = {
    "BH0992":":root {--kr-primary-color: #016936; " +
        "--kr-read-panel-bg: #b7dd90;" +
        "--kr-color-text: #595959;" +
        "--kr-border-color: #80bd01;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #80bd01;" +
        "--kr-button-color-primary: #016936;"+
        "--kr-primary-focus-color: #338760;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 60px;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-heading-color-primary: #016936;}",
    "BH0996":":root{--kr-primary-color: #000; " +
        "--kr-margin-side-primary: 89.5px;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-focus-text-color: #ccc;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #000;" +
        "--kr-primary-border-color-button: #000;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0996-en-ca":":root{--kr-primary-color: #000; " +
        "--kr-margin-side-primary: 89.5px;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-focus-text-color: #ccc;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #000;" +
        "--kr-primary-border-color-button: #000;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-html-font-size:10;" +
        "--star-size:2rem;"+
        "--kr-summary-star-size:2.8rem;" +
        "--kr-star-spacing:.5rem;"+
        "--kr-scroll-top-margin-desktop:100px;" +
        "--kr-margin-side-primary: 200px;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0996-fr-ca":":root{--kr-primary-color: #000; " +
        "--kr-margin-side-primary: 89.5px;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-focus-text-color: #ccc;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #000;" +
        "--kr-primary-border-color-button: #000;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-html-font-size:10;" +
        "--star-size:2rem;"+
        "--kr-star-spacing:.5rem;"+
        "--kr-summary-star-size:2.8rem;" +
        "--kr-scroll-top-margin-desktop:100px;" +
        "--kr-margin-side-primary: 200px;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0998":":root{--kr-primary-color: #1d4f91; " +
        "--kr-read-summary-text-primary: #1d4f91;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #1d4f91;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #1d4f91;" +
        "--kr-button-color-primary: #ccc;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #1d4f91;" +
        "--kr-primary-focus-color: #1d4f91;" +
        "--kr-focus-text-color: #ccc;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0413":":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #103073;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #103073;" +
        "--kr-customer-image-section-margin: 30px;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: center;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-button-text-color-primary: #1d4f91;" +
        "--kr-primary-focus-color: #1d4f91;" +
        "--kr-button-color-primary: #ccc;" +
        "--kr-focus-text-color: #ccc;" +
        "--kr-font-size-type: em;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-star-color: #103073;}",
    "BH0413-en-gb":":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #103073;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #103073;" +
        "--kr-customer-image-section-margin: 30px;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-font-size-type: em;" +
        "--kr-star-color: #103073;}",
    "BH0045":":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #5560ff;" +
        "--kr-border-color-tertiary: #5560ff;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #000;" +
        "--kr-color-text: #646363;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #c2ff00;" +
        "--kr-focus-text-color: #000;" +
        "--kr-text-color-label-primary: #000;" +
        "--kr-button-text-color-primary: #c2ff00;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-read-summary-text-primary: #5560ff;" +
        "--kr-padding-top-primary: 90px;" +
        "--kr-scroll-top-margin-mobile: 60px;" +
        "--kr-scroll-top-margin-desktop: 125px;" +
        "--kr-checkmark-focus-check-color: #c2ff00;" +
        "--kr-star-color: #5560ff;}",
    "BH0045-en-ca":":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #5560ff;" +
        "--kr-border-color-tertiary: #5560ff;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #000;" +
        "--kr-color-text: #646363;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #c2ff00;" +
        "--kr-focus-text-color: #000;" +
        "--kr-text-color-label-primary: #000;" +
        "--kr-button-text-color-primary: #c2ff00;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-read-summary-text-primary: #5560ff;" +
        "--kr-padding-top-primary: 90px;" +
        "--kr-html-font-size:10;" +
        "--star-size:2rem;"+
        "--kr-star-spacing:.5rem;"+
        "--kr-summary-star-size:2.8rem;" +
        "--kr-scroll-top-margin-mobile: 60px;" +
        "--kr-scroll-top-margin-desktop: 125px;" +
        "--kr-checkmark-focus-check-color: #c2ff00;" +
        "--kr-star-color: #5560ff;}",
    "BH0045-fr-ca":":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #5560ff;" +
        "--kr-border-color-tertiary: #5560ff;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #000;" +
        "--kr-color-text: #646363;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #c2ff00;" +
        "--kr-focus-text-color: #000;" +
        "--kr-text-color-label-primary: #000;" +
        "--kr-button-text-color-primary: #c2ff00;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-read-summary-text-primary: #5560ff;" +
        "--kr-padding-top-primary: 90px;" +
        "--kr-html-font-size:10;" +
        "--star-size:2rem;"+
        "--kr-star-spacing:.5rem;"+
        "--kr-summary-star-size:2.8rem;" +
        "--kr-scroll-top-margin-mobile: 60px;" +
        "--kr-scroll-top-margin-desktop: 125px;" +
        "--kr-checkmark-focus-check-color: #c2ff00;" +
        "--kr-star-color: #5560ff;}",
    "BH0977":":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #5560ff;" +
        "--kr-border-color-tertiary: #5560ff;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #000;" +
        "--kr-color-text: #646363;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #c2ff00;" +
        "--kr-focus-text-color: #000;" +
        "--kr-checkmark-focus-check-color: #c2ff00;" +
        "--kr-text-color-label-primary: #000;" +
        "--kr-button-text-color-primary: #c2ff00;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-read-summary-text-primary: #5560ff;" +
        "--kr-padding-top-primary: 90px;" +
        "--kr-star-color: #5560ff;}",
    "BH0871":":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #23246c;" +
        "--kr-border-color-tertiary: #23246c;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #23246c;" +
        "--kr-read-summary-text-primary: #23246c;" +
        "--kr-color-text: #646363;" +
        "--kr-button-color-primary: #23246c;" +
        "--kr-primary-focus-color: #ccc;" +
        "--kr-focus-text-color: #23246c;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-filter-focus-text-color: #23246c;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #23246c;" +
        "--kr-heading-color-primary: #23246c;" +
        "--kr-primary-shadow-color-button: transparent;" +
        "--kr-star-color: #0065bb;}",
    "BH1011":":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #fff;" +
        "--kr-focus-text-color: #000;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0194":":root{--kr-primary-color: #c06; " +
        "--kr-color-text: ##666;" +
        "--kr-border-color: #c06;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #c06;" +
        "--kr-button-color-primary: #fff;" +
        "--kr-primary-focus-color: #c06;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #c06;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #c06;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0460":":root{--kr-primary-color: #164c9d; " +
        "--kr-read-summary-text-primary: #164c9d;" +
        "--kr-button-color-primary: #333;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #164c9d;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 0;}",
    "BH0437-el-gr": ":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #002072;" +
        "--kr-read-summary-text-primary: #003e83;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #002072;" +
        "--kr-color-text: #4f5256;" +
        "--kr-button-color-primary: #e70033;" +
        "--kr-primary-focus-color: #e70033;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #002072;" +
        "--kr-heading-color-primary: #002072;" +
        "--kr-margin-side-primary: 80px;" +
        "--kr-star-color: #ffd32e;}",
    "BH0437": ":root{--kr-star-background-color: #ccc;" +
        "--kr-border-color: #002072;" +
        "--kr-read-summary-text-primary: #fff;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #002072;" +
        "--kr-color-text: #4f5256;" +
        "--kr-button-color-primary: #e70033;" +
        "--kr-primary-focus-color: #e70033;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #002072;" +
        "--kr-heading-color-primary: #002072;" +
        "--kr-margin-side-primary: 80px;" +
        "--kr-star-color: #ffd32e;}",
    "BF0426":":root{--kr-star-background-color: #777;" +
        "--kr-border-color: #007a33;" +
        "--kr-border-color-tertiary: #007a33;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #007a33;" +
        "--kr-color-text: #777;" +
        "--kr-button-color-primary: #007a33;" +
        "--kr-primary-focus-color: #ffd32e;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: center;" +
        "--kr-text-color-label-primary: #007a33;" +
        "--kr-heading-color-primary: #007a33;" +
        "--kr-margin-side-primary: 90px;" +
        "--kr-padding-top-primary: 80px;" +
        "--kr-star-color: #ffd32e;}",
    "BF0426-en-ae":":root{--kr-star-background-color: #fff;" +
        "--kr-border-color: #007a33;" +
        "--kr-border-color-tertiary: #d0b17a;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #007a33;" +
        "--kr-color-text: #777;" +
        "--kr-button-color-primary: #007a33;" +
        "--kr-primary-focus-color: #ffd32e;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: center;" +
        "--kr-text-color-label-primary: #007a33;" +
        "--kr-heading-color-primary: #007a33;" +
        "--kr-margin-side-primary: 90px;" +
        "--kr-padding-top-primary: 80px;" +
        "--kr-star-color: #ffd32e;}",
    "BF0432":":root{--kr-star-background-color: #777;" +
        "--kr-border-color: #164240;" +
        "--kr-border-color-tertiary: #164240;" +
        "--kr-summary-star-size: 20px;" +
        "--kr-primary-color: #164240;" +
        "--kr-color-text: #777;" +
        "--kr-button-color-primary: #164240;" +
        "--kr-primary-focus-color: #ffd32e;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #164240;" +
        "--kr-heading-color-primary: #164240;" +
        "--kr-star-color: #ffd32e;}",
    "BF0543":":root{--kr-primary-color: #c79652; " +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-color-primary: #fff;" +
        "--kr-button-text-color-primary: #c79652;" +
        "--kr-primary-focus-color: #c79652;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #c79652;" +
        "--kr-border-color-tertiary: #c79652;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #c79652;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: center;}",
    "BH8702":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #413f47;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 0;}",
    "BH0381":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #fff;" +
        "--kr-star-color: #fcce03;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 0;}",
    "BH0468":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;}",
    "BF0870-en-gb":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #000;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: transparent;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 115px;}",
    "BF0870-en-in":":root{--kr-primary-color: #46a916; " +
        "--kr-button-color-primary: #ccc;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #46a916;" +
        "--kr-primary-focus-color: #46a916;" +
        "--kr-color-text: #46a916;" +
        "--kr-border-color: #ccc;" +
        "--kr-border-color-tertiary: #fff;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #fd0;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-read-summary-text-primary: #fff;" +
        "--kr-margin-side-primary: 0;}",
    "BF0870":":root{--kr-primary-color: red; " +
        "--kr-button-color-primary: #ccc;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: red;" +
        "--kr-primary-focus-color: red;" +
        "--kr-color-text: red;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #fff;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: red;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-read-summary-text-primary: #fff;" +
        "--kr-margin-side-primary: 0;}",
    "BF0648":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-heading-color-primary: #000;" +
        "--kr-margin-side-primary: 0;}",
    "BH0307":":root{--kr-primary-color: #6e1189; " +
        "--kr-button-color-primary: #b41aa0;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #6e1189;" +
        "--kr-color-text: #6e1189;" +
        "--kr-border-color: #6e1189;" +
        "--kr-border-color-tertiary: #b41aa0;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #6e1189;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: center;" +
        "--kr-heading-color-primary: #6e1189;" +
        "--kr-margin-side-primary: 0;}",
    "BH0117":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #fff;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #000;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 110px;}",
    "BF0380":":root{--kr-star-background-color: #777;" +
        "--kr-read-panel-bg: #fdf6e8;" +
        "--kr-border-color: #004976;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-summary-star-size: 30px;" +
        "--kr-primary-color: #004976;" +
        "--kr-color-text: #777;" +
        "--kr-button-color-primary: #fdf6e8;" +
        "--kr-primary-focus-color: #004976;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #004976;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #000;" +
        "--kr-heading-color-primary: #000;" +
        "--kr-star-color: #f6d32a;}",
    "BF0380-en-ca":":root{--kr-star-background-color: #777;" +
        "--kr-read-panel-bg: #fdf6e8;" +
        "--kr-border-color: #004976;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-summary-star-size: 30px;" +
        "--kr-primary-color: #004976;" +
        "--kr-color-text: #777;" +
        "--kr-button-color-primary: #fdf6e8;" +
        "--kr-primary-focus-color: #004976;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #004976;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #000;" +
        "--kr-heading-color-primary: #000;" +
        "--kr-star-color: #f6d32a;}",
    "BF0380-fr-ca":":root{--kr-star-background-color: #777;" +
        "--kr-read-panel-bg: #fdf6e8;" +
        "--kr-border-color: #004976;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-summary-star-size: 30px;" +
        "--kr-primary-color: #004976;" +
        "--kr-color-text: #777;" +
        "--kr-button-color-primary: #fdf6e8;" +
        "--kr-primary-focus-color: #004976;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #004976;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-text-color-label-primary: #000;" +
        "--kr-heading-color-primary: #000;" +
        "--kr-star-color: #f6d32a;}",
    "BH0990":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #d2b365;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 0;}",
    "BH0990-en-ca":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #d2b365;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--star-size:2rem;"+
        "--kr-star-spacing:.5rem;"+
        "--kr-summary-star-size:2.8rem;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-html-font-size:10;" +
        "--kr-scroll-top-margin-desktop: 100px;" +
        "--kr-margin-side-primary: 200px;}",
    "BH0990-fr-ca":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #d2b365;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--star-size:2rem;"+
        "--kr-star-spacing:.5rem;"+
        "--kr-summary-star-size:2.8rem;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-scroll-top-margin-desktop: 100px;" +
        "--kr-html-font-size:10;" +
        "--kr-margin-side-primary: 200px;}",
    "BH0107":":root{--kr-primary-color: #165648; " +
        "--kr-button-color-primary: #165648;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #099;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #eba434;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-heading-color-primary: #165648;" +
        "--kr-margin-side-primary: 100px;}",
    "BH0479":":root{--kr-primary-color: #046938; " +
        "--kr-button-color-primary: #046938;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #054124;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #046938;" +
        "--kr-border-color-tertiary: #046938;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #046938;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-heading-color-primary: #165648;" +
        "--kr-read-summary-text-primary: #046938;" +
        "--kr-margin-side-primary: 90px;}",
    "BFA077":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 0;}",
    "BF0735":":root{--kr-primary-color: #666; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-color-text: #666;" +
        "--kr-border-color: #666;" +
        "--kr-border-color-tertiary: #666;" +
        "--kr-star-background-color: #666;" +
        "--kr-star-color: #ebcd34;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 0;}",
    "BH0432":":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #333132;" +
        "--kr-primary-focus-color: #333132;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0272":":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #25346d;" +
        "--kr-primary-focus-color: #1c9cd3 ;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0433":":root{--kr-primary-color: #000; " +
        "--kr-button-color-primary: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-padding-review-header-side-primary: 0;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;}",
    "living-hygiene":":root{--kr-primary-color: #333; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #25346d;" +
        "--kr-primary-focus-color: #1c9cd3;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0472":":root{--kr-primary-color: #333; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #ed0677;" +
        "--kr-border-color-tertiary: #ed0677;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #ed0677;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 70px;" +
        "--kr-font-size-type: em;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF0632":":root{--kr-primary-color: #333; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF1062":":root{--kr-primary-color: #333; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #FACC00;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH8801": ":root{--kr-primary-color: #164240; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #164240;" +
        "--kr-border-color-tertiary: #164240;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #f4af35;" +
        "--kr-button-color-primary: #164240;" +
        "--kr-primary-focus-color: #f7f7f7;" +
        "--kr-focus-text-color: #164240;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0499":":root{--kr-primary-color: #666; " +
        "--kr-color-text: #666;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #054385;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0118":":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #ff3400;" +
        "--kr-button-color-primary: #7dd0c1;" +
        "--kr-primary-focus-color: #7dd0c1;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #000;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #000;}",
    "BH0121": ":root{--kr-primary-color: #666; " +
        "--kr-color-text: #666;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #144482;" +
        "--kr-primary-focus-color: #31618e;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0048": ":root{--kr-primary-color: #00adee; " +
        "--kr-color-text: #666;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #00adee;" +
        "--kr-star-background-color: #f4f5f6;" +
        "--kr-summary-star-size: 18px;" +
        "--kr-star-color: #00adee;" +
        "--kr-button-color-primary: #00adee;" +
        "--kr-primary-focus-color: #e40037;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 70px;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BFA081": ":root{--kr-primary-color: #666; " +
        "--kr-read-panel-bg: #d8e2bb;" +
        "--kr-color-text: #666;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #286140;" +
        "--kr-primary-focus-color: #378558;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH8837": ":root{--kr-primary-color: #666; " +
        "--kr-color-text: #666;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #fff;" +
        "--kr-star-color: #de605f;" +
        "--kr-button-color-primary: #444;" +
        "--kr-primary-focus-color: #444;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0873": ":root{--kr-primary-color: #007b4b; " +
        "--kr-read-panel-bg: #e5f2ed;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #e5f2ed;" +
        "--kr-primary-focus-color: #323b42;" +
        "--kr-focus-text-color: #007b4b;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-text-color-primary: #007b4b;" +
        "--kr-summary-listing-widget-aligment: flex-start;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0128": ":root{--kr-primary-color: #b41a6f; " +
        "--kr-read-panel-bg: #000;" +
        "--kr-write-review-bg: #f4f4f4;" +
        "--kr-heading-color-primary: #fff;" +
        "--kr-color-text: #fff;" +
        "--kr-border-color: #b41a6f;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #fff;" +
        "--kr-primary-focus-color: #b41a6f;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #b41a6f;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF8813": ":root{--kr-primary-color: #666; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #facc00;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BHA102": ":root{--kr-primary-color: #bc1f89; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #bc1f89;" +
        "--kr-border-color-tertiary: #bc1f89;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #bc1f89;" +
        "--kr-button-color-primary: #bc1f89;" +
        "--kr-primary-focus-color: #bc1f89;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-read-panel-bg: #f2f4f6;" +
        "--kr-margin-side-primary: 50px;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF0726": ":root{--kr-primary-color: #666; " +
        "--kr-color-text: #666;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #facc00;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0356": ":root{--kr-primary-color: #077d40; " +
        "--kr-read-panel-bg: #ecf3ec;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #686868;" +
        "--kr-star-color: #077d40;" +
        "--kr-button-color-primary: #077d40;" +
        "--kr-primary-focus-color: #fff;" +
        "--kr-focus-text-color: #077d40;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BHA123": ":root{--kr-primary-color: #000; " +
        "--kr-read-panel-bg: #f2f4f6;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #00a3ff;" +
        "--kr-button-color-primary: #00a2ff;" +
        "--kr-primary-focus-color: #00a2ff;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF0073": ":root{--kr-primary-color: #000; " +
        "--kr-read-panel-bg: #f2f4f6;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #009c4e;" +
        "--kr-primary-focus-color: #009c4e;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BHA003": ":root{--kr-primary-color: #006a39; " +
        "--kr-read-panel-bg: #f2f4f6;" +
        "--kr-color-text: #000;" +
        "--kr-heading-color-primary: #006a39;" +
        "--kr-text-color-label-primary: #006a39;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #006a39;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #006a39;" +
        "--kr-button-color-primary: #006938;" +
        "--kr-primary-focus-color: #94c900;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0300": ":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #666;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BFA098": ":root{--kr-primary-color: #001c71; " +
        "--kr-read-panel-bg: #d7eef4;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #001c71;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: transparent;" +
        "--kr-primary-focus-color: #001c71;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #001c71;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF8817": ":root{--kr-primary-color: #493627; " +
        "--kr-color-text: #493627;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #ffff00;" +
        "--kr-button-color-primary: #999966;" +
        "--kr-primary-focus-color: #bebe9d;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BFA070": ":root{--kr-primary-color: #00735f; " +
        "--kr-read-panel-bg: #f4f4f4;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #00735f;" +
        "--kr-border-color-tertiary: transparent;" +
        "--kr-star-background-color: #9b999a;" +
        "--kr-star-color: #00735f;" +
        "--kr-button-color-primary: #00735f;" +
        "--kr-primary-focus-color: #000;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF0136": ":root{--kr-primary-color: #000; " +
        "--kr-read-panel-bg: #f2f4f6;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #d87f0c;" +
        "--kr-primary-focus-color: #d87f0c;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH1000": ":root{--kr-primary-color: #000; " +
        "--kr-read-panel-bg: #f7f7f7;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #8f8f8f;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0875": ":root{--kr-primary-color: #023471; " +
        "--kr-read-panel-bg: #f4f4f4;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #023471;" +
        "--kr-primary-focus-color: #3b5998;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-margin-side-primary: 130px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0124":":root{--kr-primary-color: #10155e; " +
        "--kr-read-panel-bg: #fe6a76;" +
        "--kr-button-color-primary: #10155e;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-heading-color-primary: #10155e;" +
        "--kr-text-color-label-primary: #10155e;" +
        "--kr-read-summary-text-primary: #666;" +
        "--kr-primary-focus-color: #41afd9;" +
        "--kr-color-text: #10155e;" +
        "--kr-border-color: #10155e;" +
        "--kr-border-color-tertiary: #10155e;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-color-text-secondary: #10155e;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #10155e;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;}",
    "sensitive-mineral-active": ":root{--kr-primary-color: #000; " +
        "--kr-read-panel-bg: #f4f4f4;" +
        "--kr-color-text: #04c6c6;" +
        "--kr-border-color: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #1a8a8f;" +
        "--kr-primary-focus-color: #6cbec2;" +
        "--kr-focus-text-color: #000;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BHA122": ":root{--kr-primary-color: #72f14d; " +
        "--kr-read-panel-bg: #f7f7f7;" +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #72f14d;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-margin-side-primary: 100px;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH1005": ":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF1013": ":root{--kr-primary-color: #114f73; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #114f73;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #114f73;" +
        "--kr-primary-focus-color: #005b93;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH8800": ":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #323b42;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BF0688": ":root{--kr-primary-color: #000; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #000;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #333;" +
        "--kr-primary-focus-color: #555;" +
        "--kr-focus-text-color: #fff;" +
        "--padding-side-primary: 0px;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-margin-side-primary: 10px;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BH0173": ":root{--kr-primary-color: #00aebb; " +
        "--kr-color-text: #fff;" +
        "--kr-read-panel-bg: #000;" +
        "--kr-write-review-bg: #f4f4f4;" +
        "--kr-border-color: #00aebb;" +
        "--kr-border-color-tertiary: #00aebb;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #00aebb;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #323b42;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-heading-color-primary: #00aebb;" +
        "--kr-text-color-label-primary: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #fff;}",
    "BHA305": ":root{--kr-primary-color: #875810; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #875810;" +
        "--kr-border-color-tertiary: #875810;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #875810;" +
        "--kr-primary-focus-color: #e2c57b;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #000;}",
    "BH0997": ":root{--kr-primary-color: #63b1e5; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #63b1e5;" +
        "--kr-border-color-tertiary: #63b1e5;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #000;" +
        "--kr-primary-focus-color: #d9017a;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #000;}",
    "BH0869": ":root{--kr-primary-color: #003b6f; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #003b6f;" +
        "--kr-border-color-tertiary: #a37073;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #a37073;" +
        "--kr-button-color-primary: transparent;" +
        "--kr-primary-focus-color: #a37073;" +
        "--kr-focus-text-color: #f4f4f4;" +
        "--kr-button-text-color-primary: #a37073;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;" +
        "--kr-button-text-color-secondary: #000;}",
    "BH1081": ":root{--kr-primary-color: #54b7b7; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #25275e;" +
        "--kr-border-color-tertiary: #000;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #000;" +
        "--kr-button-color-primary: #54b7b7;" +
        "--kr-primary-focus-color: #296262;" +
        "--kr-heading-color-primary: #25275e;" +
        "--kr-text-color-label-primary: #25275e;" +
        "--kr-focus-text-color: #000;" +
        "--kr-button-text-color-primary: #000;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;}",
    "unilever-food-solutions": ":root{--kr-primary-color: #ff5a00; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #ff5a00;" +
        "--kr-border-color-tertiary: #ff5a00;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #ff5a00;" +
        "--kr-button-color-primary: #ff5a00;" +
        "--kr-primary-focus-color: #ff7d29;" +
        "--kr-heading-color-primary: #000;" +
        "--kr-text-color-label-primary: #ff5a00;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;}",
    "BH1036": ":root{--kr-primary-color: #35ae46; " +
        "--kr-color-text: #000;" +
        "--kr-border-color: #35ae46;" +
        "--kr-border-color-tertiary: #ff5a00;" +
        "--kr-star-background-color: #ccc;" +
        "--kr-star-color: #35ae46;" +
        "--kr-button-color-primary: #78bf3e;" +
        "--kr-primary-focus-color: #35ae46;" +
        "--kr-heading-color-primary: #000;" +
        "--kr-text-color-label-primary: #35ae46;" +
        "--kr-focus-text-color: #fff;" +
        "--kr-button-text-color-primary: #fff;" +
        "--kr-summary-listing-widget-aligment: center;" +
        "--kr-summary-detail-widget-aligment: flex-start;}"
};